// removed by extract-text-webpack-plugin
module.exports = {"packageWrapper":"_2ymgmA76vO5qIhBCDJHAND","titleWrapper":"PDYJP8kfetnf62FUo_pD0","priceWrapper":"_13JC1PSrErkPooCCOu9kty","withoutDiscount":"_1MbOogsZJJIWqcqWTV7c_d","publisherPackageWrapper":"_1mZr5PR7Zzm-JtYmCufLQ7"};


//////////////////
// WEBPACK FOOTER
// ./src/components/PackageTitleForPayment/PackageTitleForPayment.scss
// module id = 1692
// module chunks = 0